import { FC, memo } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Fade,
  Flex,
  Stack,
  Text,
} from '@chakra-ui/react'

type Props = {
  content: JSX.Element
  contentWhenClosed?: JSX.Element
  title: string
  description?: string
  isOpen?: boolean
  onClose?: () => void
  onOpen?: () => void
}

const FilterTemplate: FC<Props> = ({
  content,
  contentWhenClosed,
  title,
  description = 'Aparecerá os campos que você pesquisou ao fechar este formulário.',
  onClose,
  onOpen,
  isOpen = false,
}) => {
  function toggleAccordion() {
    if (isOpen) {
      if (onClose) onClose()
    } else {
      if (onOpen) onOpen()
    }
  }

  return (
    <Accordion index={isOpen ? [0] : [1]} allowMultiple>
      <AccordionItem bg="light" border="none" borderBottom="2px solid" borderColor="borderColor">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              p={4}
              border="none"
              _hover={{ '.filter-groups': { color: 'primary' }, '.pencil': { color: 'primary' } }}
              onClick={toggleAccordion}
            >
              <Flex width="100%" direction="column">
                <Flex justify="space-between" gap={2}>
                  <Flex direction="column" textAlign="left" gap={1}>
                    <Flex className="filter-groups" align="center" gap={2}>
                      <Text fontSize="md" className="accessible">
                        {title}
                      </Text>
                    </Flex>
                    {description && <Text variant="secondary">{description}</Text>}
                  </Flex>

                  <AccordionIcon boxSize={6} />
                </Flex>
              </Flex>
            </AccordionButton>

            {!isExpanded && (
              <Fade in={!isExpanded}>
                <Stack>{contentWhenClosed}</Stack>
              </Fade>
            )}

            <AccordionPanel pb={4}>{isExpanded && content}</AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}

export default memo(FilterTemplate)
